import { DeploymentRequest } from "../../services/deployment-requests";

export type DeploymentRequestListPageState = {
  dipByRgn: string;
  schedDateRange: DateRange;
  incClosed: boolean;
  dplymntEnv: string;
  /**
   * Page List
   */
  searchResult: {
    deploymentRequestList: DeploymentRequest[];
  };
  fieldPath: {
    dipByRgn: string;
    schedDateStart: string;
    schedDateEnd: string;
    incClosed: string;
    dplymntEnv: string;
  };
};

export type SpreadsheetState = {
  deploymentRequestList: DeploymentRequest[];
  removeMilliseconds: (timestamp: string) => string;
};

export type DateRange = {
  startDate: string;
  endDate: string;
};

export type PageNewState =
  | DeploymentRequestListPageState
  | ((
      prevState: DeploymentRequestListPageState,
    ) => DeploymentRequestListPageState);
